module.exports = __webpack_public_path__ + "static/media/dualSeniorBlock.b0f680f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualSeniorBlock.png
// module id = 472
// module chunks = 0